import Config from '@/config';
import { formatByteSize } from "@/filters";
import i18n from "@/plugins/i18n"

export const ProcedureDocumentType = {
    PROTOCOL:  { code: 1, label: i18n.global.t('Выписка из реестра договоров') },
    PROCEDURE: { code: 2, label: i18n.global.t('Документация') },
    AGREEMENT: { code: 3, label: i18n.global.t('Договор') },
    PROJECT_AGREEMENT: { code: 4, label: i18n.global.t('Проект договора') },
};

export const checkFileValidation = function (file) {
    let cfg = Config.get('config');

    const allowedExtensions = (cfg.allowedUploadExtensions || []).map(ext => ext.toLowerCase());
    const allowedMimeTypes = (cfg.allowedUploadMimeTypes || []);
    const maxSize = cfg.maxDocUploadSize;

    const ext = file.name.slice(file.name.lastIndexOf('.')).toLowerCase();

    if (maxSize && file.size > maxSize) {
        return i18n.global.t(`"{_1}" — Превышает максимальный размер {_2}`, {'_1': file.name, '_2': formatByteSize(maxSize)});
    }

    if (file.size === 0) {
        return i18n.global.t((`"{_1}" — Файл пустой (0 байт). Пожалуйста, загрузите файл с данными`, {'_1': file.name}));
    }

    if (!allowedExtensions.includes(ext)) {
        return i18n.global.t(`"{_1}" — Недопустимый формат файла ({_2})`, {'_1': file.name, '_2': ext});
    }

    if (!allowedMimeTypes.includes(file.type)) {
        return i18n.global.t(`"{_1}" — Недопустимый MIME-тип файла ({_2})`, {'_1': file.name, '_2': file.type});
    }

    return true;
};
